var _rect, _rect2, _path, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgNight = function SvgNight(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 25,
    viewBox: "0 0 36 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.111328,
    width: 36,
    height: 24,
    rx: 12,
    fill: "url(#paint0_linear_431_490)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    y: 0.111328,
    width: 36,
    height: 24,
    rx: 12,
    fill: "url(#paint1_linear_431_490)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24 14.4179C23.212 14.7742 22.3372 14.9726 21.4161 14.9726C17.9492 14.9726 15.1387 12.1622 15.1387 8.69525C15.1387 7.77414 15.3371 6.89937 15.6935 6.11133C13.5155 7.09631 12 9.28815 12 11.8339C12 15.3008 14.8105 18.1113 18.2774 18.1113C20.8232 18.1113 23.015 16.5959 24 14.4179Z",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_431_490",
    x1: 30.5,
    y1: 18.1113,
    x2: 16.5554,
    y2: -2.77338,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#31026B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6A00FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_431_490",
    x1: 32.5135,
    y1: 0.111336,
    x2: 1.19513,
    y2: 3.03414,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#02256B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00A3FF"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgNight);
export default ForwardRef;